import vosClient, { IVosResponse } from "../../vosClient";

export interface HrDataSearchItem {
  UserID: string;
  UserCode: string;
  UserName: string;
  UserType: string;
  Level_1_Code: string;
  Level_2_Code: string;
  Level_3_Code: string;
  Level_1_Name: string;
  Level_2_Name: string;
  Level_3_Name: string;
  Code_Job_Title: string;
  Name_Job_Title: string;
  Dep_Code: string;
  Dep_Name: string;
  HR_ID: number;
  Email: string;
}

export interface IGetHrDataSearchParams {
  module: string;
  keySearch: string;
  depID?: number;
}

export class HrDataSearchService {
  static async getHrData(params: IGetHrDataSearchParams): Promise<IVosResponse<HrDataSearchItem[]>> {
    const response = await vosClient.get<IVosResponse<HrDataSearchItem[]>>("/api/functionregister/hr-data-search", {
      params,
    });

    return response.data;
  }
}
